export default __webpack_public_path__ + "static/media/siteLogo.ba56cd8c.png";